import type { NowomedAndroidInterface } from '../hooks/useIsAndroidApp';

declare global {
  interface Window {
    NowomedAndroidInterface?: NowomedAndroidInterface;
  }
}

export const handlePaymentRedirect = (url: string) => {
  // openPaymentUrl is a function defined in the Mobile repository > MainActivity.kt
  if (window.NowomedAndroidInterface && typeof window.NowomedAndroidInterface.openPaymentUrl === 'function') {
    window.NowomedAndroidInterface.openPaymentUrl(url);
  } else {
    window.location.href = url;
  }
};
